//Author Aiwin Charalil Manuel
import React from 'react';
import '../../stylesheets/about.css'; 

const About = () => {
  return (
    <div className="about-container h-100">
      <h1>About Us</h1>
      <div className="paragraph-container"> 
        <p>
          Hey there, book lovers!
        </p>
        <p>
          Are you itching for a reading experience that's as thrilling as turning the next page of your favorite book? Well, welcome to Book Stack, where we're flipping the script on traditional book borrowing and opening the doors to a world of endless reading possibilities. Say goodbye to the limited shelf space and hello to a library that's as expansive as your imagination!
        </p>
        <p>
          <b>So what are we offering?</b>
        </p>
        <p>
        Explore and Choose!! Book Stack isn't just about books – it's about offering you a selection across genres, authors, and popularity. From bestsellers to the classics, our app ensures you always have something new and exciting to explore. Sign up with our app and explore exciting features. Book Stack makes it easy to discover your next reading adventure!!
        </p>
        <p>
        That's not it! Whether you're a book lover who can't put a book down, need reading material on-the-go, or a library aiming to boost its online presence, Book Stack is the solution you need. Our user-friendly app ensures a seamless experience from sign-up to book reservations. With features like personalized recommendations and easy checkout systems, Book Stack guarantees a smooth reading journey for everyone.
        </p>
        <p>
        So, what are you waiting for? Grab your favorite drink, cozy up in your favorite reading corner, and dive into Book Stack today. Let's redefine the rules of reading, sharing, and connecting together. Because with Book Stack, the adventure never ends – it's a never-ending story waiting for you to turn the page!
        </p>
      </div> 
    </div>
  );
}

export default About;

